<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <h5>Asistente para el registro de usuarios administrativos y de soporte</h5>
    <div style="display: flex; justify-content: space-between; background-color: #f0f0f0; padding: 10px; border-radius: 5px;">
      <h4>Paso 2: Tipo de Usuario</h4>
<!--
      <h4 style="margin: 0;">
        <span class="btn btn-secondary">1</span>
        <span class="btn btn-success"><b>2</b></span>
        <span class="btn btn-secondary">3</span>
      </h4>
-->
    </div>
    <hr>
<!-- Modal -->
<div class="modal-dialog modal-xl" style="z-index: 1;">
    <div class="modal-content">
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idUsuario" class="form-label">IdUsuario</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idUsuario" name="idUsuario" v-model="datoUsuario.idUsuario" disabled>
                </div>
              </div>
            </div>
<!-- Botón Lista de Valores  Perfil -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idPerfil" class="form-label"> Perfil</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idPerfil" name="idPerfil" v-model="datoUsuario.idPerfil">
                      <option v-for="perfil in perfils" :value="perfil.idPerfil" :key="perfil.idPerfil">
                        {{ perfil.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Perfil -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombre" class="form-label">Nombre</label>
                </div>
                <div class="col-10">
                  <input type="text" class="form-control" id="nombre" name="nombre" v-model="datoUsuario.nombre" disabled>
                </div>
              </div>
            </div>
            <hr>
             <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="clave" class="form-label">Clave</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="clave" name="clave" v-model="datoUsuario.clave" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-3">
                  <input type="checkbox" id="moduloAdministracion" name="moduloAdministracion" v-model="moduloAdministracionBoolean">
                  <label for="moduloAdministracion" class="form-label" style="margin-left: 8px;">ModuloAdministracion</label>
                </div>
                <div class="col-3">
                  <input type="checkbox" id="moduloAtencion" name="moduloAtencion" v-model="moduloAtencionBoolean">
                  <label for="moduloAtencion" class="form-label" style="margin-left: 8px;">ModuloAtencion</label>
                </div>
                <div class="col-3">
                  <input type="checkbox" id="moduloFacturacion" name="moduloFacturacion" v-model="moduloFacturacionBoolean">
                  <label for="moduloFacturacion" class="form-label" style="margin-left: 8px;">ModuloFacturacion</label>
                </div>
                <div class="col-3">
                  <input type="checkbox" id="moduloDashboards" name="moduloDashboards" v-model="moduloDashboardsBoolean">
                  <label for="moduloDashboards" class="form-label" style="margin-left: 8px;">ModuloDashboards</label>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-3">
                  <input type="checkbox" id="menuParametros" name="menuParametros" v-model="menuParametrosBoolean">
                  <label for="menuParametros" class="form-label" style="margin-left: 8px;">MenuParametros</label>
                </div>
                <div class="col-3">
                  <input type="checkbox" id="menuProcesos" name="menuProcesos" v-model="menuProcesosBoolean">
                  <label for="menuProcesos" class="form-label" style="margin-left: 8px;">MenuProcesos</label>
                </div>
                <div class="col-3">
                  <input type="checkbox" id="menuReportes" name="menuReportes" v-model="menuReportesBoolean">
                  <label for="menuReportes" the="form-label" style="margin-left: 8px;">MenuReportes</label>
                </div>
                <div class="col-3">
                  <input type="checkbox" id="menuAyuda" name="menuAyuda" v-model="menuAyudaBoolean">
                  <label for="menuAyuda" class="form-label" style="margin-left: 8px;">MenuAyuda</label>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-3">
                  <input type="checkbox" id="opcionConsulta" name="opcionConsulta" v-model="opcionConsultaBoolean">
                  <label for="opcionConsulta" class="form-label" style="margin-left: 8px;">OpcionConsulta</label>
                </div>
                <div class="col-3">
                  <input type="checkbox" id="opcionOperaciones" name="opcionOperaciones" v-model="opcionOperacionesBoolean">
                  <label for="opcionOperaciones" class="form-label" style="margin-left: 8px;">OpcionOperaciones</label>
                </div>
                <div class="col-3">
                  <input type="checkbox" id="opcionDescarga" name="opcionDescarga" v-model="opcionDescargaBoolean">
                  <label for="opcionDescarga" class="form-label" style="margin-left: 8px;">OpcionDescarga</label>
                </div>
                <div class="col-3">
                  <input type="checkbox" id="opcionMenu" name="opcionMenu" v-model="opcionMenuBoolean">
                  <label for="opcionMenu" class="form-label" style="margin-left: 8px;">OpcionMenu</label>
                </div>
              </div>
            </div>
            <hr>
            <button @click.prevent="mostrarOcultarBloque">{{ mostrarBloque ? '(-) Menos información' : '(+) Más información' }}</button>
            <div v-if="mostrarBloque" class="mb-3">
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idSuscripcion" class="form-label"> Suscripcion</label>
                  </div>
                  <div class="col-10">
                    <input type="text" class="form-control" id="idSuscripcion" name="idSuscripcion" v-model="datoUsuario.idSuscripcion" disabled>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idUsuarioReg" class="form-label">IdUsuarioReg</label>
                  </div>
                  <div class="col-10">
                  <input type="text" class="form-control" id="idUsuarioReg" name="idUsuarioReg" v-model="datoUsuario.idUsuarioReg" disabled>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idUsuarioAct" class="form-label">IdUsuarioAct</label>
                  </div>
                  <div class="col-10">
                  <input type="text" class="form-control" id="idUsuarioAct" name="idUsuarioAct" v-model="datoUsuario.idUsuarioAct" disabled>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="fechaReg" class="form-label">FechaReg</label>
                  </div>
                  <div class="col-10">
                  <input type="text" class="form-control" id="fechaReg" name="fechaReg" v-model="datoUsuario.fechaReg" disabled>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="fechaAct" class="form-label">FechaAct</label>
                  </div>
                  <div class="col-10">
                  <input type="text" class="form-control" id="fechaAct" name="fechaAct" v-model="datoUsuario.fechaAct" disabled>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <button type="submit" class="btn btn-light" @click.prevent="guardarUsuario" title="Continuar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">navigate_next</i>
        </button>
      </div>
    </div>
  </div>
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import dateFormat from '@/modules/dateFormat.js';
import { validarForm } from '@/modules/validacionesForms.js'
import { createBooleanField } from '@/modules/casillaVerificacion.js'

import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal2 from  'sweetalert2'
export default {
  components : {
    Layout, Footer
  },
  data () {
    return {
      usuarios : [],
      datoUsuario : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      modalWindow: true,
      mostrarBloque: false,
      p_idUsuario: 0,
      p_idPersona: 0,
      perfils: [],
      suscripcions: [],
      modulo: 0,
      showModalHelp: false,
      estiloImagen: {
        width: "200px",
        height: "200px"
      }
    }
  },
  computed: {
  
    moduloAdministracionBoolean: createBooleanField('moduloAdministracion'),
    moduloAtencionBoolean: createBooleanField('moduloAtencion'),
    moduloFacturacionBoolean: createBooleanField('moduloFacturacion'),
    moduloDashboardsBoolean: createBooleanField('moduloDashboards'),
    menuParametrosBoolean: createBooleanField('menuParametros'),
    menuProcesosBoolean: createBooleanField('menuProcesos'),
    menuReportesBoolean: createBooleanField('menuReportes'),
    menuAyudaBoolean: createBooleanField('menuAyuda'),
    opcionConsultaBoolean: createBooleanField('opcionConsulta'),
    opcionOperacionesBoolean: createBooleanField('opcionOperaciones'),
    opcionDescargaBoolean: createBooleanField('opcionDescarga'),
    opcionMenuBoolean: createBooleanField('opcionMenu')
  },
  mounted () {
    this.p_idUsuario = this.$route.params.p_idusuario
    this.modulo = window.sessionStorage.getItem("modulo")
    this.p_idPersona = window.sessionStorage.getItem("idPersona");
    // this.getData()
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
    this.fetchPerfils()
    this.datoUsuario.nombre = window.sessionStorage.getItem("nombreUsuario");
//    this.fetchSuscripcions()
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    mostrarOcultarBloque() {
      this.mostrarBloque = !this.mostrarBloque;
    },
/*    getData() {
      api.get('/vwusuarios/'+this.p_idUsuario)
        .then(response => {
          this.datoUsuario = response.data;
        })
        .catch(error => {
         console.error('Error al obtener datos de la persona:', error);
        });
    }, */
    validarForm(){
      const requiredFields = [
        'idPerfil'
//        ,'idSuscripcion'
        ,'nombre'
        ,'clave'
/*         ,'moduloAdministracion'
        ,'moduloAtencion'
        ,'moduloFacturacion'
        ,'moduloDashboards'
        ,'menuParametros'
        ,'menuProcesos'
        ,'menuReportes'
        ,'menuAyuda'
        ,'opcionConsulta'
        ,'opcionOperaciones'
        ,'opcionDescarga'
        ,'opcionMenu' */
      ];
      const requiredFieldsText = [
        'idPerfil'
//        ,'idSuscripcion'
        ,'nombre'
        ,'clave'
/*         ,'moduloAdministracion'
        ,'moduloAtencion'
        ,'moduloFacturacion'
        ,'moduloDashboards'
        ,'menuParametros'
        ,'menuProcesos'
        ,'menuReportes'
        ,'menuAyuda'
        ,'opcionConsulta'
        ,'opcionOperaciones'
        ,'opcionDescarga'
        ,'opcionMenu' */
      ];
      return validarForm(this.datoUsuario, requiredFields, requiredFieldsText);
    },    
/*     async guardarUsuario(){
      if(this.validarForm() === 1){
        try {
          this.datoUsuario.idPersona = this.p_idPersona;
          this.datoUsuario.idUsuario = this.p_idUsuario;
          this.datoUsuario.idSuscripcion = window.sessionStorage.getItem("idSuscripcion");
          this.datoUsuario.idEmpresa = window.sessionStorage.getItem("idEmpresa");
          this.datoUsuario.idUsuarioReg = window.sessionStorage.getItem("idUsuario");
          await api.post('/usuarios', this.datoUsuario)
          swal("Correcto!", "Usuario creada exitosamente!", "success");
          this.$router.push('/usuarioadm03/'+this.medicos.idMedico)
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    }, */
    async guardarUsuario() {
      if (this.validarForm() === 1) {
        try {
          // Prepara los datos del usuario para enviar
          this.datoUsuario.idPersona = this.p_idPersona;
          this.datoUsuario.idUsuario = this.p_idUsuario;
          this.datoUsuario.idSuscripcion = window.sessionStorage.getItem("idSuscripcion");
          this.datoUsuario.idEmpresa = window.sessionStorage.getItem("idEmpresa");
          this.datoUsuario.idUsuarioReg = window.sessionStorage.getItem("idUsuario");

          // Realiza la petición POST y espera la respuesta
          const response = await api.post('/usuarios', this.datoUsuario);

          // Recupera el idUsuario de la respuesta
          const idUsuarioCreado = response.data.idUsuario;
          console.log("Usuario creado con ID:", idUsuarioCreado);

          // Muestra un mensaje de éxito incluyendo el idUsuario
          swal2.fire({
            title: "Usuario Creado Exitosamente!",
            text: `El usuario ha sido creado con el ID: ${idUsuarioCreado}.`,
            icon: "success",
            confirmButtonText: "Aceptar"
          }).then(() => {
            // Aquí decides qué hacer después, por ejemplo, redirigir a otra ruta
            this.$router.push(`/usuarioadm03/${idUsuarioCreado}`);
          });

        } catch (error) {
          console.error("Error en la creación del usuario:", error);
          swal2.fire({
            title: "Error",
            text: "Inténtelo de nuevo!",
            icon: "error",
            confirmButtonText: "Reintentar"
          });
        }
      }
    },
/*     async guardarEditUsuario(){
      if(this.validarForm() === 1){
        try {
          this.datoUsuario.idUsuarioAct = window.sessionStorage.getItem("idUsuario");
          await api.post('/usuarios', this.datoUsuario)
          swal("Correcto!", "Usuario creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    }, */
    fetchPerfils() {
      fetch('http://localhost:8080/api/v1/vwperfils')
        .then(response => response.json())
        .then(data => {
          this.perfils = data;
        })
        .catch(error => {
          console.error('Error fetching perfils:', error);
        });
    },
/*    
    fetchSuscripcions() {
      fetch('http://localhost:8080/api/v1/suscripcions')
        .then(response => response.json())
        .then(data => {
          this.suscripcions = data;
        })
        .catch(error => {
          console.error('Error fetching suscripcions:', error);
        });
    }, */
    openHelp() {
      this.popupAyuda = true;
      this.$refs.helpPopup.open();
    },
    handlePopupClosed() {
      this.popupAyuda = false;
    }
  },
}
</script>
<style src="@/assets/css/listaFiltrada.css" scoped></style>